export enum CareerCenterModal {
  Description = 'Description',
  SkillInformation = 'SkillInformation',
}
